import Component from "@base/js/component";
import Drawer from "@components/drawer/drawer";
import $ from "jquery";

export default class MapPathing extends Component {
  // Defines the element selector which will initialize this component
  static selector = ".map-pathing";

  // Defines children that needs to be queried as part of this component
  static children = {
    mapContainer: ".map-pathing__map",
    mapContainerInfoBox: "#map-pathing__info-box",
    selectionItems: [".map-pathing__selection-item"],
    selectionHeading: ".map-pathing__selection-heading",
    selectionHeadingText: ".map-pathing__selection-heading-text",
  };

  // Defines sub components that needs to be queried as part of this component
  static members = {
    drawers: [Drawer],
  };

  // Defines event handlers to attach to children
  eventHandlers = {
    selectionItems: {
      click: this.onSelectionStateClick,
    },
  };

  // Will be called upon component instantiation
  afterInit() {
    const { mapContainer } = this.children;
    const mapInfoBox = this.children.mapContainerInfoBox;
    if (mapContainer) {
      const svg = mapContainer.querySelector("#svg-us-map");
      if (svg) {
        const pathCircles = svg.querySelectorAll("path,circle");
        pathCircles.forEach((item) => {
          item.addEventListener(
            "mouseover",
            () => {
              mapInfoBox.classList.add("map-pathing__info-box--show");
              document.querySelector("#map-pathing__info-box").innerHTML = item
                .getAttribute("data-info")
                .toString();
            },
            false
          );
          item.addEventListener(
            "mouseout",
            () => {
              mapInfoBox.classList.remove("map-pathing__info-box--show");
            },
            false
          );
          item.addEventListener(
            "click",
            () => {
              this.mapStateSelected(item);
            },
            false
          );
        });

        if (pathCircles) {
          svg.addEventListener("mousemove", (e) => {
            const x = e.clientX - mapInfoBox.offsetWidth / 2;
            const y = e.clientY - (mapInfoBox.offsetHeight + 12);
            mapInfoBox.style.left = `${x}px`;
            mapInfoBox.style.top = `${y}px`;
          });
        }
      }
    }

    // Add event listener to check if the user clicks outside the container
    $(document).on("click", (event) => {
      if (!$(event.target).closest(".map-pathing__selection-drawer").length) {
        if ($(".map-pathing__selection-drawer .drawer--expanded").length > 0)
          this.children.selectionHeading.click();
      }
    });
  }

  onSelectionStateClick(e) {
    const { selectionHeading } = this.children;
    const item = e.target;
    const value = item.getAttribute("data-value");
    const name = item.innerText;
    if (name && value) {
      selectionHeading.click();
      this.updateSelectionValue(name, value);
    }
  }

  updateSelectionValue(name, value) {
    const { selectionHeading, selectionHeadingText, mapContainer } =
      this.children;
    const svg = mapContainer.querySelector("#svg-us-map");
    selectionHeadingText.innerHTML = name;
    selectionHeading.setAttribute("data-selected-value", value);

    if (svg) {
      svg.classList.add("has-selected-state");
      let selectedStatePath = null;
      if (value.includes("/")) {
        selectedStatePath = svg.querySelector(`[data-info='${name.trim()}'`);
      } else {
        selectedStatePath = svg.querySelector(`#${value}`);
      }

      if (selectedStatePath) {
        svg
          .querySelectorAll("*[data-id]")
          .forEach((el) => el.classList.remove("state-selected"));
        selectedStatePath.classList.add("state-selected");
      }
      if (value.includes("/")) {
        window.location.href = value;
      }
    }
  }

  mapStateSelected(item) {
    const name = item.getAttribute("data-info").toString();
    let value = item.getAttribute("data-id").toString();

    // check if value is link
    const items = this.children.selectionItems;
    if (items) {
      const trimmedValue = [...items].map((el) => ({
        dataValue: el.dataset.value,
        name: el.dataset.name,
      }));
      if (trimmedValue) {
        const selectValue = trimmedValue.find(
          (el) => el.name.trim().toLowerCase() === name.trim().toLowerCase()
        );
        if (selectValue) {
          value = selectValue.dataValue;
        }
      }
    }
    this.updateSelectionValue(name, value);
  }
}

// Remove this line if this component is not intended
// to initialize on DOM load.
MapPathing.init();
